import script from "./ProfileMatchesEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileMatchesEditor.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileMatchesEditor.vue?vue&type=style&index=0&id=96b01322&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96b01322"]])

export default __exports__